export default "__VITE_ASSET__BrSM2jYA__"